import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import {HttpClient, HttpEvent} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../_model/ApiResponse';
import {AbsenceRequest} from '../_model/request/AbsenceRequest';
import {AbsenceReportRequest} from '../_model/request/AbsenceReportRequest';
import {Absence, AbsenceRejectRequest} from '../_model/Absence';
import {AbsenceDeservedRequest} from '../_model/request/AbsenceDeservedRequest';
import {HrAdminAbsenceRequest} from '../_model/request/HrAdminAbsenceRequest';
import {AbsenceSearchRequest} from '../_model/request/AbsenceSearchRequest';

@Injectable({
  providedIn: 'root'
})
export class AbsenceService extends BaseService {


  constructor(http: HttpClient) {
    super(http);
  }

  approveAbsence(request): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/wf/approvals', request);
  }
  rejectAbsence(request: AbsenceRejectRequest): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/absences/reject', request);
  }
  saveAbsence(absenceRequest: AbsenceRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/absences', absenceRequest);
  }

  updateAbsence(absenceRequest: AbsenceRequest): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/absences', absenceRequest);
  }

  updateAbsenceByAdminAndHr(absenceRequest: HrAdminAbsenceRequest): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/absences/admin', absenceRequest);
  }

  listAbsences(): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/absences');
  }

  deleteAbsence(absence: Absence): Observable<ApiResponse> {
    return this.delete<ApiResponse>('/api/v1/absences/' + absence.id);
  }

  uploadAbsenceFile(formData: FormData, recordId: number): Observable<HttpEvent<ApiResponse>> {
    return this.upload<ApiResponse>('/api/v1/absences/uploadfile/' + recordId, formData);
  }

  getAbsenceDeserved(absenceDeservedRequest: AbsenceDeservedRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/absences/getAbsenceDeserved', absenceDeservedRequest);
  }

  listAbsenceMyRequest(absenceSearchRequest: AbsenceSearchRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/absences/myrequests', absenceSearchRequest);
  }
  listAbsenceWaitings(absenceSearchRequest: AbsenceSearchRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/absences/waitingforapprovals', absenceSearchRequest);
  }
  listAbsenceMyApproveds(absenceSearchRequest: AbsenceSearchRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/absences/approveds', absenceSearchRequest);
  }
  listAbsenceAll(absenceSearchRequest: AbsenceSearchRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/absences/all', absenceSearchRequest);
  }
  listAbsenceRejecteds(absenceSearchRequest: AbsenceSearchRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/absences/rejecteds', absenceSearchRequest);
  }
  getReportData( absenceReportRequest:AbsenceReportRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/absences/report', absenceReportRequest);
  }

}
